<bit-dialog dialogSize="large">
  <div bitDialogContent class="tw-pb-0">
    <bit-svg
      [content]="marketingSvg"
      [ariaLabel]="'inviteLinkCalloutImageAlt' | i18n"
      class="tw-mx-2"
    ></bit-svg>
    <div class="tw-px-12 tw-pt-6 tw-text-center">
      <div class="tw-px-12">
        <h2 class="tw-mb-4">
          {{ "inviteLinkCalloutHeading" | i18n }}
        </h2>
        <p class="tw-mb-0 tw-text-fg-body-subtle">
          {{ "inviteLinkCalloutBody" | i18n }}
        </p>
      </div>
    </div>
  </div>
  <div bitDialogFooter class="tw-w-full tw-flex tw-justify-center tw-gap-4 tw-pb-3">
    <button
      id="invite-link-callout-dialog_button_skip"
      bitButton
      buttonType="secondary"
      type="button"
      (click)="close('skip')"
    >
      {{ "skip" | i18n }}
    </button>
    <button
      id="invite-link-callout-dialog_button_show-me-how"
      bitButton
      buttonType="primary"
      type="button"
      (click)="close('showMeHow')"
    >
      {{ "showMeHow" | i18n }}
    </button>
  </div>
</bit-dialog>
